import { TrackDeliveryPanelTab } from 'src/redux/slices/trackDeliveryPanel/slice'
import { ActionType } from '../baseAction.types'

export type OverlayAction = {
  type: ActionType.Overlay
  data: OverlayActionData
}

export enum OverlayResource {
  HomeCalendarSelector = 'HOME_CALENDAR_SELECTOR',
  AddExtraDeliveryDay = 'EXTRA_DELIVERY_DAY_ADDER',
  RescheduleOrder = 'RESCHEDULE_ORDER_MANAGER',
  OrderTimeline = 'ORDER_TIMELINE_INFORMER',
  OrderManagement = 'ORDER_ACTIONS_MANAGER',
  OrderTracking = 'ORDER_TRACKING_INFORMER',
  OrderInvoice = 'ORDER_INVOICE_INFORMER',
  ExpressAccessDummy = 'EXPRESS_ACCESS_DUMMY', // TODO: update this after definition
  CartDetail = 'CART_DETAIL_INFORMER',
  OrderUnskip = 'ORDER_UNSKIPPER',
  OrderSkip = 'ORDER_SKIPPER'
}

export enum OverlayLayout {
  Modal = 'MODAL',
  Panel = 'PANEL',
  Popover = 'POPOVER'
}

export enum OverlayPosition {
  Right = 'RIGHT',
  Center = 'CENTER'
}

type OverlayActionParameters = Partial<{
  date: string
  type: TrackDeliveryPanelTab
}>

type OverlayActionData = {
  layout: OverlayLayout
  resource: OverlayResource
  position?: OverlayPosition
  parameters?: OverlayActionParameters
}
